import React from "react";

const IconElement = ( { iconName, style }) =>
{
    return (
        <span className={ iconName} style={style}/>
    )
}

export default IconElement ;
